module.exports = __webpack_public_path__ + "img/rose-6.e339d4cb.png";